// Sticky Cards Animation (ES Module)
// Uses global gsap, ScrollTrigger, and Lenis from window object

document.addEventListener("DOMContentLoaded", () => {
     if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
          console.warn('⚠️ Sticky Cards: GSAP or ScrollTrigger not loaded');
          return;
     }
     
     gsap.registerPlugin(ScrollTrigger);

     const lenis = new Lenis();
     lenis.on("scroll", ScrollTrigger.update);
     gsap.ticker.add((time) => {
          lenis.raf(time * 1000);
     });
     gsap.ticker.lagSmoothing(0);

     let stickyTriggers = [];

     function killStickyTriggers() {
          stickyTriggers.forEach(t => {
               try { t.kill(); } catch (e) { }
          });
          stickyTriggers = [];
     }

     function initStickyCards() {
          const cards = gsap.utils.toArray(".sticky-cards .card");
          // Ensure later cards stack above earlier ones so the previous fades BEHIND the next
          const baseZ = 10; // keep well below header/nav (which is ~1000)
          cards.forEach((c, i) => {
               const z = baseZ + i;
               c.style.zIndex = String(z);
               const parent = c.parentElement;
               if (parent && parent.classList.contains('pin-spacer')) {
                    parent.style.zIndex = String(z);
               }
          });
          cards.forEach((card, index) => {
               if (index >= cards.length - 1) return;
               const cardInner = card.querySelector(".card-inner");
               if (!cardInner) return;

               const tween1 = gsap.fromTo(
                    cardInner,
                    { y: "0%", z: 0, rotationX: 0 },
                    {
                         y: "-50%",
                         z: -250,
                         rotationX: 45,
                         scrollTrigger: {
                              trigger: cards[index + 1],
                              start: "top 85%",
                              end: "top -75%",
                              scrub: true,
                              pin: card,
                              pinSpacing: false,
                              anticipatePin: 1,
                              pinReparent: true,
                              invalidateOnRefresh: true,
                              onEnter: () => {
                                   const z = baseZ + index;
                                   card.style.zIndex = String(z);
                                   const parent = card.parentElement;
                                   if (parent && parent.classList.contains('pin-spacer')) parent.style.zIndex = String(z);
                              },
                              onEnterBack: () => {
                                   const z = baseZ + index;
                                   card.style.zIndex = String(z);
                                   const parent = card.parentElement;
                                   if (parent && parent.classList.contains('pin-spacer')) parent.style.zIndex = String(z);
                              }
                         }
                    }
               );
               if (tween1 && tween1.scrollTrigger) stickyTriggers.push(tween1.scrollTrigger);

               const tween2 = gsap.to(cardInner, {
                    "--after-opacity": 1,
                    scrollTrigger: {
                         trigger: cards[index + 1],
                         start: "top 75%",
                         end: "top -25%",
                         scrub: true,
                         invalidateOnRefresh: true
                    }
               });
               if (tween2 && tween2.scrollTrigger) stickyTriggers.push(tween2.scrollTrigger);
          });
     }

     // Recompute on refresh-init to clear transforms before measuring
     ScrollTrigger.addEventListener('refreshInit', () => {
          document.querySelectorAll('.sticky-cards .card .card-inner').forEach(el => {
               el.style.transform = '';
          });
     });

     // Initialize and set up debounced resize handling
     initStickyCards();

     let resizeTimer;
     window.addEventListener('resize', () => {
          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(() => {
               killStickyTriggers();
               initStickyCards();
               ScrollTrigger.refresh();
          }, 150);
     });
     
     console.log('✅ Sticky Cards animation initialized');
});

export default {};
